@if (isLoggedIn) {
  <div class="user-menu">
    @if ((isHandset$ | async) === false) {
      <button mat-button [matMenuTriggerFor]="menu" #menutrigger="matMenuTrigger">
        <div class="user-icon">{{ user?.first_name[0] | uppercase }}</div>
        @if (!menutrigger.menuOpen) {
          <mat-icon iconPositionEnd>expand_more</mat-icon>
        }
        @if ( menutrigger.menuOpen) {
          <mat-icon  iconPositionEnd>expand_less</mat-icon>
        }
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <div class="user-menu-name">{{user?.first_name}} {{user?.last_name}}</div>
        <div class="user-menu-email">
          <mat-icon>email</mat-icon>
          {{user?.email}}
        </div>
        <a mat-menu-item class="user-menu-item"
          [routerLink]="['/user']"
          [queryParams]="{ user_id: user?.user_id }">
          <mat-icon>account_circle</mat-icon>
          View Profile
        </a>
        <button mat-menu-item class="user-menu-item" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Sign out
        </button>
      </mat-menu>
    } @else {
      <button class="menu-trigger font-family-sans" type="button" (click)="openMenu()" aria-label="Open menu">
        <span>MENU</span>
      </button>
      @if (sideNavOpen) {
        <mat-sidenav-container
          class="portable-shell"
          [hasBackdrop]="true"
          >
          <mat-sidenav position="end" mode="over" [opened]="true" (closedStart)="onDrawerClosed()"
            role="dialog" aria-label="Main menu">
            <div class="drawer">
              <button class="drawer__close" type="button"
              (click)="onDrawerClosed()" aria-label="Close menu">✕</button>
              <div class="drawer__topbar-space"></div>
              <nav class="drawer__nav" aria-label="Primary">
                <a routerLink="/dashboard"        routerLinkActive="is-active" (click)="onDrawerClosed()">Dashboard</a>
                <a routerLink="/fire-tracker"     routerLinkActive="is-active" (click)="onDrawerClosed()">Fire Tracker</a>
                <a routerLink="/assessments" routerLinkActive="is-active" (click)="onDrawerClosed()">BAER Assessments</a>
                <a routerLink="/roster"           routerLinkActive="is-active" (click)="onDrawerClosed()">Roster</a>
                <a routerLink="/data-manipulation"             routerLinkActive="is-active" (click)="onDrawerClosed()">Data Manipulation</a>
              </nav>
              <div class="drawer__profile">
                <div class="who">
                  <div class="name">{{user?.first_name}} {{user?.last_name}}</div>
                  <div class="email"><mat-icon>email</mat-icon><span>{{user?.email}}</span></div>
                </div>
              </div>
              <div class="drawer__actions">
                <a class="action"
                  [routerLink]="['/user']"
                  [queryParams]="{ user_id: user?.user_id }"
                  (click)="onDrawerClosed()">
                  <mat-icon>account_circle</mat-icon><span>View Profile</span>
                </a>
                <a class="action"
                  [routerLink]="['/support']"
                  (click)="onDrawerClosed()"
                  >
                  <mat-icon>help_outline</mat-icon><span>Support</span>
                </a>
                <button class="action linkish" type="button" (click)="onDrawerClosed(); logout()">
                  <mat-icon>logout</mat-icon><span>Sign out</span>
                </button>
              </div>
            </div>
          </mat-sidenav>
          <mat-sidenav-content></mat-sidenav-content>
        </mat-sidenav-container>
      }
    }
  </div>
}
